import {
  Category,
  ImpactCo2Answer,
} from '@/domain/impact-co2/entities/question.entity';

import { getImpactAnswersForCategory } from './get-impact-answers-for-category';

const CATEGORY_TO_GET: Category[] = [
  'ACCOMMODATION',
  // 'ACCOMMODATION_PUBLIC',
  'BUILDING',
  'CARGO',
  'CATERING_BEVERAGE',
  'CATERING_MEAL',
  'DIGITAL',
  'ENERGY',
  'EQUIPMENT',
  'GENERATOR',
  'MOBILITY',
  // 'MOBILITY_PUBLIC',
  'NON_RECYCLABLE_WASTE',
  'RECYCLABLE_WASTE',
  'WATER',
  'SCENOGRAPHY_NO_RECYCLABLE',
  'SCENOGRAPHY_RECYCLABLE',
  'OFFICE_SUPPLIES_REFURBISH',
  'OFFICE_SUPPLIES_NEW',
  'TEAM_MOBILITY',
  'BUILDING_HEATING',
];

export async function getImpactAnswers(
  projectId: number,
): Promise<ImpactCo2Answer[]> {
  const promises = CATEGORY_TO_GET.map((category) =>
    getImpactAnswersForCategory(projectId, category),
  );
  const results = await Promise.all(promises);
  const answers = results.flat();
  return answers;
}
